// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var JsxRuntime = require("react/jsx-runtime");
var TextInputNew$ReactHooksTemplate = require("../common/TextInputNew.res.js");

var stackedContainerClassName = "flex flex-col gap-2";

var stackedInputBoxClassName = "flex flex-col w-full";

var stackedTextInputClassName = "w-full outline-none border border-gray-300 h-11 rounded-lg px-3 text-sm focus:border-pigmentblue focus:ring-1 focus:ring-pigmentblue";

var stackedLabelClassName = "text-sm font-medium text-darkcharcoal";

function ModalFormLayout$Shell(props) {
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx("div", {
                      children: props.body,
                      className: "flex-1 overflow-y-auto min-h-0"
                    }),
                props.footer
              ],
              className: "flex flex-col flex-1 min-h-0"
            });
}

var Shell = {
  make: ModalFormLayout$Shell
};

function ModalFormLayout(props) {
  var __discardLabel = props.discardLabel;
  var __discardDisabled = props.discardDisabled;
  var primaryDisabled = props.primaryDisabled;
  var onPrimary = props.onPrimary;
  var onDiscard = props.onDiscard;
  var discardDisabled = __discardDisabled !== undefined ? __discardDisabled : false;
  var discardLabel = __discardLabel !== undefined ? __discardLabel : "Discard";
  return JsxRuntime.jsx("div", {
              children: JsxRuntime.jsxs("div", {
                    children: [
                      JsxRuntime.jsx("button", {
                            children: discardLabel,
                            className: "w-full sm:w-auto border border-gray-300 rounded-lg py-2.5 px-5 text-sm font-semibold text-darkcharcoal bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-gray-300 disabled:opacity-50",
                            disabled: discardDisabled,
                            type: "button",
                            onClick: (function (param) {
                                Curry._1(onDiscard, undefined);
                              })
                          }),
                      JsxRuntime.jsx("button", {
                            children: props.primaryLabel,
                            className: "w-full sm:w-auto rounded-lg py-2.5 px-5 text-sm font-semibold text-white focus:outline-none focus:ring-2 focus:ring-pigmentblue " + (
                              primaryDisabled ? "bg-pigmentblue opacity-50 cursor-not-allowed" : "bg-pigmentblue hover:bg-cetaceanblue"
                            ),
                            disabled: primaryDisabled,
                            type: "button",
                            onClick: (function (param) {
                                Curry._1(onPrimary, undefined);
                              })
                          })
                    ],
                    className: "flex flex-col-reverse sm:flex-row gap-3 sm:justify-end"
                  }),
              className: "flex-shrink-0 px-5 py-4 border-t border-gray-200 bg-gray-50"
            });
}

function ModalFormLayout$TemplateFooter(props) {
  var templateSelected = props.templateSelected;
  var onChooseTemplate = props.onChooseTemplate;
  var onCreateFromScratch = props.onCreateFromScratch;
  var onBack = props.onBack;
  return JsxRuntime.jsx("div", {
              children: JsxRuntime.jsxs("div", {
                    children: [
                      JsxRuntime.jsx("button", {
                            children: "Back",
                            className: "w-full sm:w-auto py-2.5 px-5 text-sm font-semibold text-aurometalsaurus hover:text-darkcharcoal focus:outline-none",
                            type: "button",
                            onClick: (function (param) {
                                Curry._1(onBack, undefined);
                              })
                          }),
                      JsxRuntime.jsx("button", {
                            children: "Create from Scratch",
                            className: "w-full sm:w-auto border border-gray-300 rounded-lg py-2.5 px-5 text-sm font-semibold text-darkcharcoal bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-gray-300",
                            type: "button",
                            onClick: (function (param) {
                                Curry._1(onCreateFromScratch, undefined);
                              })
                          }),
                      JsxRuntime.jsx("button", {
                            children: "Choose Template",
                            className: "w-full sm:w-auto rounded-lg py-2.5 px-5 text-sm font-semibold text-white focus:outline-none focus:ring-2 focus:ring-pigmentblue " + (
                              templateSelected ? "bg-pigmentblue hover:bg-cetaceanblue" : "bg-pigmentblue opacity-50 cursor-not-allowed"
                            ),
                            disabled: !templateSelected,
                            type: "button",
                            onClick: (function (param) {
                                Curry._1(onChooseTemplate, undefined);
                              })
                          })
                    ],
                    className: "flex flex-col-reverse sm:flex-row gap-3 sm:justify-end sm:flex-wrap"
                  }),
              className: "flex-shrink-0 px-5 py-4 border-t border-gray-200 bg-gray-50"
            });
}

var TemplateFooter = {
  make: ModalFormLayout$TemplateFooter
};

function ModalFormLayout$SurveyFields(props) {
  var name = props.name;
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx(TextInputNew$ReactHooksTemplate.make, {
                      label: "Survey Name",
                      value: name,
                      handleChange: props.onNameChange,
                      maxLength: 100,
                      textInputClassName: stackedTextInputClassName,
                      containerClassName: stackedContainerClassName,
                      labelClassName: stackedLabelClassName,
                      inputBoxContainerCss: stackedInputBoxClassName
                    }),
                name === "" ? JsxRuntime.jsx("p", {
                        children: "Name can't be empty",
                        className: "text-red-500 text-xs mt-1.5"
                      }) : (
                    props.nameError ? JsxRuntime.jsx("p", {
                            children: "Special characters are not allowed",
                            className: "text-red-500 text-xs mt-1.5"
                          }) : null
                  ),
                JsxRuntime.jsx("div", {
                      children: JsxRuntime.jsxs("div", {
                            children: [
                              JsxRuntime.jsxs("div", {
                                    children: [
                                      JsxRuntime.jsx("p", {
                                            children: "Quiz Mode",
                                            className: "text-sm font-medium text-darkcharcoal"
                                          }),
                                      JsxRuntime.jsx("p", {
                                            children: "Enable scoring and quiz-style questions",
                                            className: "text-xs text-aurometalsaurus mt-0.5"
                                          })
                                    ]
                                  }),
                              JsxRuntime.jsxs("label", {
                                    children: [
                                      JsxRuntime.jsx("input", {
                                            checked: props.isQuizModeActive,
                                            type: "checkbox",
                                            onChange: props.onCategoryToggle
                                          }),
                                      JsxRuntime.jsx("span", {
                                            className: "slider round"
                                          })
                                    ],
                                    className: "switch flex-shrink-0"
                                  })
                            ],
                            className: "flex items-center justify-between gap-4"
                          }),
                      className: "mt-6 p-4 rounded-lg border border-gray-200 bg-gray-50"
                    })
              ],
              className: "px-5 py-5 sm:px-6 sm:py-6"
            });
}

var SurveyFields = {
  make: ModalFormLayout$SurveyFields
};

function ModalFormLayout$ProjectNameField(props) {
  var name = props.name;
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx(TextInputNew$ReactHooksTemplate.make, {
                      label: "Project Name",
                      value: name,
                      handleChange: props.onNameChange,
                      maxLength: 100,
                      textInputClassName: stackedTextInputClassName,
                      containerClassName: stackedContainerClassName,
                      labelClassName: stackedLabelClassName,
                      inputBoxContainerCss: stackedInputBoxClassName
                    }),
                name === "" ? JsxRuntime.jsx("p", {
                        children: "Name can't be empty",
                        className: "text-red-500 text-xs mt-1.5"
                      }) : (
                    props.nameError ? JsxRuntime.jsx("p", {
                            children: "Special characters are not allowed",
                            className: "text-red-500 text-xs mt-1.5"
                          }) : null
                  )
              ],
              className: "px-5 py-5 sm:px-6 sm:py-6"
            });
}

var ProjectNameField = {
  make: ModalFormLayout$ProjectNameField
};

var make = ModalFormLayout;

exports.stackedContainerClassName = stackedContainerClassName;
exports.stackedInputBoxClassName = stackedInputBoxClassName;
exports.stackedTextInputClassName = stackedTextInputClassName;
exports.stackedLabelClassName = stackedLabelClassName;
exports.Shell = Shell;
exports.make = make;
exports.TemplateFooter = TemplateFooter;
exports.SurveyFields = SurveyFields;
exports.ProjectNameField = ProjectNameField;
/* react/jsx-runtime Not a pure module */
